import { useMemo } from 'react';
import { parseHTMLString } from 'utils/utility-functions';

export function SecondaryNotice({ notice }) {
  const parsedNotice = useMemo(() => parseHTMLString(notice), [notice]);

  if (!parsedNotice) return null;
  return parsedNotice;
}
